import { fbTrack } from './fb-track.js';
export const fbTrackLetterGrade = ({ me: { letterGrade = '' } = {} }) => {
    if (['A', 'B', 'C'].includes(letterGrade)) {
        fbTrack('trackCustom', 'CreditPlus', {}, true);
        fbTrack('track', 'AddPaymentInfo');
    }
    else if (['D', 'F'].includes(letterGrade)) {
        fbTrack('trackCustom', 'Credit', {}, true);
    }
};
//# sourceMappingURL=fb-track-letter-grade.js.map